// @owners { team: patients-team }
import { SPACING } from '@alto/design-library-tokens';
import { ActionSheetV2, Body, LgPadding } from '@alto/design-system';
import React from 'react';
import { getIsGskUser } from '~shared/features/users/selectors/getIsGskUser';
import { useSelectorShared } from '~shared/store';

export const GSK_FEE_DETAILS_COPY =
  'The delivery fee includes the cost to ship your order, as well as a pharmacy dispensing fee of $15.';

export const FeeDetailsActionSheet = () => {
  const isGSKUser = useSelectorShared(getIsGskUser);

  return (
    <ActionSheetV2
      title="Fee details"
      analyticsName="fee details"
    >
      <LgPadding topPadding={SPACING.STATIC.NONE}>{isGSKUser ? <Body>{GSK_FEE_DETAILS_COPY}</Body> : null}</LgPadding>
    </ActionSheetV2>
  );
};
